import {
    SET_NODES, SET_DEVICE_TYPES, SET_DEVICE_STATUSES, SET_NODE_STATUSES, SET_PROXIES, SET_DEVICE_PROXY_STATUSES,
    SET_DEVICE_HEALTH_STATUSES, SET_PROXY_GROUPS, SET_NODE_IPS, SET_DEVICE_PROXY_MODES,
} from "./consts";

// Все справочники — объекты формата {id: label} (как отдаёт app-init).
export const setNodes = (nodes) => ({ type: SET_NODES, payload: nodes });

export const setDeviceTypes = (deviceTypes) => ({ type: SET_DEVICE_TYPES, payload: deviceTypes });

export const setDeviceStatuses = (deviceStatuses) => ({ type: SET_DEVICE_STATUSES, payload: deviceStatuses });

export const setNodeStatuses = (nodeStatuses) => ({ type: SET_NODE_STATUSES, payload: nodeStatuses });

export const setProxies = (proxies) => ({ type: SET_PROXIES, payload: proxies });

export const setDeviceProxyStatuses = (deviceProxyStatuses) => ({ type: SET_DEVICE_PROXY_STATUSES, payload: deviceProxyStatuses });

export const setDeviceHealthStatuses = (deviceHealthStatuses) => ({ type: SET_DEVICE_HEALTH_STATUSES, payload: deviceHealthStatuses });

export const setProxyGroups = (proxyGroups) => ({ type: SET_PROXY_GROUPS, payload: proxyGroups });

export const setNodeIps = (nodeIps) => ({ type: SET_NODE_IPS, payload: nodeIps });

export const setDeviceProxyModes = (deviceProxyModes) => ({ type: SET_DEVICE_PROXY_MODES, payload: deviceProxyModes });
